import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@routific/hive/v5';
import { useStore } from '../../../../store/mst';
import { InlineRow } from './styles';

interface Props {
  value: string;
}

const DurationRow: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation(['common', 'components']);
  const store = useStore();

  const noDuration: boolean = !!(value === '0 mins' || value === null || value === 'null mins');
  const defaultDuration = `${store.defaultOrderDuration} ${t('visitFields.duration.suffix')}`;

  if (noDuration) {
    value = defaultDuration;
  }

  return (
    <InlineRow>
      <Typography variant="body">{value}</Typography>
      {noDuration && (
        <Typography variant="body" tone="secondary">
          {t('orderDetails.default')}
        </Typography>
      )}
    </InlineRow>
  );
};

export default observer(DurationRow);
